<template>
	<div>
	  	<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="kanbanGeral">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="/kanban"> &nbsp; Kanban</a>
				</li>
			</ol>
		</div>
		
		<div class="kanbanGeral mt-2">
				
			<div id="accordionPeriodo">

				<!-- Filtro -->
				<div class="row" style="margin-top: -30px; margin-bottom: -10px; margin-right: 15px;">
					<div class="col-3"> </div>
					<div class="col-3"> 
						<v-select 
							v-if="perfil"
							placeholder="Filtro por Responsável"
							label="nome"
							@input="alteracaoUsuario()"
							v-model="responsavel"
							multiple
							:reduce="(u) => u.idusuario"
							:options="listaResponsaveis">
							<span slot="no-options" @click="$refs.select.open = false">
								Nenhum registro encontrado
							</span>
						</v-select>	
					</div>
					<div class="col-4"> 
						<v-select
							placeholder="Filtrar por Projeto"
							label="codigoNome"
							@input="carregarKanban()"
							v-model="projeto"
							multiple
							:reduce="(u) => u.idprojeto"
							:options="listaProjetos">
							<template v-slot:option="option">
								{{ option.codigoNome }} ({{option.situacaoDescricao}})
							</template>                                 
							<span slot="no-options" @click="$refs.select.open = false">
								Nenhum registro encontrado
							</span>
						</v-select>					
					</div>
					<div class="col-2">
						<div class="text-right" style="text-wrap: nowrap;">
							<b-form-group>
								<b-form-radio-group
								v-model="selecao"
								:options="opcoes"
								name="radio-inline"></b-form-radio-group>
							</b-form-group>
						</div>
					</div>
				</div>

				<div class="row opcaoAccordion p-2 m-2" id="headingSemana" 
						@click="toggleSemana"
						data-toggle="collapse" data-target="#collapseSemana" aria-expanded="true" aria-controls="collapseSemana">
					<i class="fas mt-1 mr-2"
						:class="{'fa-angle-right': isCollapsedSemana, 'fa-angle-down': !isCollapsedSemana}"
						></i> Essa semana {{kanban.periodoSemana}}
				</div>

				<div class="row collapse m-2 mt-2 kanban-periodo-scroll" id="collapseSemana" role="region" tabindex="0" aria-labelledby="headingSemana" data-parent="#accordionPeriodo">
					
					<!-- A Fazer -->
					<div class="col-12 col-md-6 col-xl-3 text-center">
						<div class="tituloColuna colunaFazer">
							<div class="central">
								<i class="far fa-clock mr-2"></i> A Fazer (<span v-if="selecao=='A'">{{demandaFazer.listaAtividadeSemana.length}}</span><span v-if="selecao=='T'">{{demandaFazer.listaTarefaSemana.length}}</span>)
							</div>
						</div>
						<div id="accordionFazerSemana">

							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFazer.listaAtividadeSemana" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazerSemana">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Atividade" placement="top">
														<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Atividade" placement="top">
														<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Atividade" placement="top">
														<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFazer.listaTarefaSemana" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazerSemana">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Tarefa" placement="top">
														<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Tarefa" placement="top">
														<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Tarefa" placement="top">
														<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Fazendo -->
					<div class="col-12 col-md-6 col-xl-3">
						<div class="text-center tituloColuna colunaFazendo">
							<div class="central">
								<i class="fas fa-cog mr-2"></i> Fazendo (<span v-if="selecao=='A'">{{demandaFazendo.listaAtividadeSemana.length}}</span><span v-if="selecao=='T'">{{demandaFazendo.listaTarefaSemana.length}}</span>)
							</div>
						</div>
						<div class="row" id="accordionFazendoSemana">

							<div class="col-12" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='A'"
									v-for="atividade in demandaFazendo.listaAtividadeSemana" :key="atividade.idatividade">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': atividade.situacao=='ATRASADA', 'cartaoFazendo': atividade.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ atividade.idatividade"
										data-toggle="collapse"
										:data-target="`#collapseA`+ atividade.idatividade"
										aria-expanded="true"
										:aria-controls="`collapseA`+ atividade.idatividade">
										<div class="divTitulo">
											<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
												<i class="text-warning fas fa-star mr-1"></i>
											</el-tooltip>
											{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ atividade.dataInicio }} a {{ atividade.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': atividade.situacao=='ATRASADA'}">
												{{ descreverSituacao(atividade.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + atividade.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazendoSemana">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Atividade" placement="top">
															<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Atividade" placement="top">
															<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Atividade" placement="top">
															<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
							<div class="col-12" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='T'"
									v-for="tarefa in demandaFazendo.listaTarefaSemana" :key="tarefa.idtarefa">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': tarefa.situacao=='ATRASADA', 'cartaoFazendo': tarefa.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ tarefa.idtarefa"
										data-toggle="collapse"
										:data-target="`#collapseA`+ tarefa.idtarefa"
										aria-expanded="true"
										:aria-controls="`collapseA`+ tarefa.idtarefa">
										<div class="divTitulo">
											{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': tarefa.situacao=='ATRASADA'}">
												{{ descreverSituacao(tarefa.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + tarefa.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazendoSemana">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Tarefa" placement="top">
															<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Tarefa" placement="top">
															<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Tarefa" placement="top">
															<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
							
						</div>
					</div>

					<!-- Atrasados de qualquer período, sempre respeitando os filtros -->
					<KanbanAtrasados
						:selecao="selecao"
						:demanda="demandaAtrasada"
						@visualizar-atividade="abrirModalAtividade"
						@alterar-atividade="alterarAtividade"
						@alterar-tarefa="modalAlterarTarefa"
						@cancelar-atividade="modalCancelarAtividade"
						@cancelar-tarefa="modalCancelarTarefa"
						@concluir-atividade="concluirAtividade"
						@concluir-tarefa="concluirTarefa" />

					<!-- Feito -->
					<div class="col-12 col-md-6 col-xl-3 text-center">
						<div class="tituloColuna colunaFeito">
							<div class="central">
								<i class="far fa-check-circle mr-2"></i> Feito (<span v-if="selecao=='A'">{{demandaFeito.listaAtividadeSemana.length}}</span><span v-if="selecao=='T'">{{demandaFeito.listaTarefaSemana.length}}</span>)
							</div>
						</div>
						<div id="accordionFeitoSemana">

							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFeito.listaAtividadeSemana" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFeitoSemana">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFeito.listaTarefaSemana" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFeitoSemana">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span style="margin-left: -10px;">
														<img :src="tarefa.criador.avatar" :title="tarefa.criador.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">

													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="row opcaoAccordion p-2 m-2 mt-1" id="headingProxima" 
						@click="toggleProxima"
						data-toggle="collapse" data-target="#collapseProxima" aria-expanded="true" aria-controls="collapseProxima">
					<i class="fas mt-1 mr-2"
						:class="{'fa-angle-right': isCollapsedProxima, 'fa-angle-down': !isCollapsedProxima}"
						></i> Próxima semana {{kanban.periodoProxima}}
				</div>

				<div class="row collapse m-2 mt-2 kanban-periodo-scroll" id="collapseProxima" role="region" tabindex="0" aria-labelledby="headingProxima" data-parent="#accordionPeriodo">
					<div class="col-3 text-center">
						<div class="tituloColuna colunaFazer">
							<div class="central">
								<i class="far fa-clock mr-2"></i> A Fazer (<span v-if="selecao=='A'">{{demandaFazer.listaAtividadeProxima.length}}</span><span v-if="selecao=='T'">{{demandaFazer.listaTarefaProxima.length}}</span>)
							</div>
						</div>
						<div id="accordionFazerProxima">
							
							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFazer.listaAtividadeProxima" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }}  
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazerProxima">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Atividade" placement="top">
														<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Atividade" placement="top">
														<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Atividade" placement="top">
														<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFazer.listaTarefaProxima" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }}  
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazerProxima">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Tarefa" placement="top">
														<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Tarefa" placement="top">
														<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Tarefa" placement="top">
														<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="col-6">
						<div class="text-center tituloColuna colunaFazendo">
							<div class="central">
								<i class="fas fa-cog mr-2"></i> Fazendo (<span v-if="selecao=='A'">{{demandaFazendo.listaAtividadeProxima.length}}</span><span v-if="selecao=='T'">{{demandaFazendo.listaTarefaProxima.length}}</span>)
							</div>
						</div>
						<div class="row" id="accordionFazendoProxima">

							<div class="col-6" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='A'"
									v-for="atividade in demandaFazendo.listaAtividadeProxima" :key="atividade.idatividade">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': atividade.situacao=='ATRASADA', 'cartaoFazendo': atividade.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ atividade.idatividade"
										data-toggle="collapse"
										:data-target="`#collapseA`+ atividade.idatividade"
										aria-expanded="true"
										:aria-controls="`collapseA`+ atividade.idatividade">
										<div class="divTitulo">
											<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
												<i class="text-warning fas fa-star mr-1"></i>
											</el-tooltip>
											{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ atividade.dataInicio }} a {{ atividade.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': atividade.situacao=='ATRASADA'}">
												{{ descreverSituacao(atividade.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + atividade.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazendoProxima">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Atividade" placement="top">
															<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Atividade" placement="top">
															<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Atividade" placement="top">
															<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
							<div class="col-6" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='T'"
									v-for="tarefa in demandaFazendo.listaTarefaProxima" :key="tarefa.idtarefa">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': tarefa.situacao=='ATRASADA', 'cartaoFazendo': tarefa.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ tarefa.idtarefa"
										data-toggle="collapse"
										:data-target="`#collapseA`+ tarefa.idtarefa"
										aria-expanded="true"
										:aria-controls="`collapseA`+ tarefa.idtarefa">
										<div class="divTitulo">
											{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': tarefa.situacao=='ATRASADA'}">
												{{ descreverSituacao(tarefa.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + tarefa.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazendoProxima">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Tarefa" placement="top">
															<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Tarefa" placement="top">
															<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Tarefa" placement="top">
															<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="col-3 text-center">
						<div class="tituloColuna colunaFeito">
							<div class="central">
								<i class="far fa-check-circle mr-2"></i> Feito (<span v-if="selecao=='A'">{{demandaFeito.listaAtividadeProxima.length}}</span><span v-if="selecao=='T'">{{demandaFeito.listaTarefaProxima.length}}</span>)
							</div>
						</div>
						<div id="accordionFeitoProxima">

							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFeito.listaAtividadeProxima" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFeitoProxima">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFeito.listaTarefaProxima" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFeitoProxima">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span style="margin-left: -10px;">
														<img :src="tarefa.criador.avatar" :title="tarefa.criador.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">

													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>

				<div class="row opcaoAccordion p-2 m-2 mt-1" id="headingMes" 
						@click="toggleMes"
						data-toggle="collapse" data-target="#collapseMes" aria-expanded="true" aria-controls="collapseMes">
					<i class="fas mt-1 mr-2"
						:class="{'fa-angle-right': isCollapsedMes, 'fa-angle-down': !isCollapsedMes}"
						></i> Próximos 30 dias {{kanban.periodo30}}
				</div>

				<div class="row collapse m-2 mt-2 kanban-periodo-scroll" id="collapseMes" role="region" tabindex="0" aria-labelledby="headingMes" data-parent="#accordionPeriodo">
					<div class="col-3 text-center">
						<div class="tituloColuna colunaFazer">
							<div class="central">
								<i class="far fa-clock mr-2"></i> A Fazer (<span v-if="selecao=='A'">{{demandaFazer.listaAtividade30.length}}</span><span v-if="selecao=='T'">{{demandaFazer.listaTarefa30.length}}</span>)
							</div>
						</div>
						<div id="accordionFazer30">

							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFazer.listaAtividade30" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }}  
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazer30">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Atividade" placement="top">
														<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Atividade" placement="top">
														<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Atividade" placement="top">
														<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFazer.listaTarefa30" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }}  
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazer30">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Tarefa" placement="top">
														<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Tarefa" placement="top">
														<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Tarefa" placement="top">
														<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
					<div class="col-6">
						<div class="text-center tituloColuna colunaFazendo">
							<div class="central">
								<i class="fas fa-cog mr-2"></i> Fazendo (<span v-if="selecao=='A'">{{demandaFazendo.listaAtividade30.length}}</span><span v-if="selecao=='T'">{{demandaFazendo.listaTarefa30.length}}</span>)
							</div>
						</div>
						<div class="row" id="accordionFazendo30">

							<div class="col-6" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='A'"
									v-for="atividade in demandaFazendo.listaAtividade30" :key="atividade.idatividade">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': atividade.situacao=='ATRASADA', 'cartaoFazendo': atividade.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ atividade.idatividade"
										data-toggle="collapse"
										:data-target="`#collapseA`+ atividade.idatividade"
										aria-expanded="true"
										:aria-controls="`collapseA`+ atividade.idatividade">
										<div class="divTitulo">
											<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
												<i class="text-warning fas fa-star mr-1"></i>
											</el-tooltip>
											{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ atividade.dataInicio }} a {{ atividade.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': atividade.situacao=='ATRASADA'}">
												{{ descreverSituacao(atividade.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + atividade.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazendo30">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Atividade" placement="top">
															<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Atividade" placement="top">
															<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Atividade" placement="top">
															<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
							<div class="col-6" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='T'"
									v-for="tarefa in demandaFazendo.listaTarefa30" :key="tarefa.idtarefa">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': tarefa.situacao=='ATRASADA', 'cartaoFazendo': tarefa.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ tarefa.idtarefa"
										data-toggle="collapse"
										:data-target="`#collapseA`+ tarefa.idtarefa"
										aria-expanded="true"
										:aria-controls="`collapseA`+ tarefa.idtarefa">
										<div class="divTitulo">
											{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': tarefa.situacao=='ATRASADA'}">
												{{ descreverSituacao(tarefa.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + tarefa.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazendo30">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Tarefa" placement="top">
															<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Tarefa" placement="top">
															<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Tarefa" placement="top">
															<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="col-3 text-center">
						<div class="tituloColuna colunaFeito">
							<div class="central">
								<i class="far fa-check-circle mr-2"></i> Feito (<span v-if="selecao=='A'">{{demandaFeito.listaAtividade30.length}}</span><span v-if="selecao=='T'">{{demandaFeito.listaTarefa30.length}}</span>)
							</div>
						</div>
						<div id="accordionFeito30">

							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFeito.listaAtividade30" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFeito30">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFeito.listaTarefa30" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFeito30">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span style="margin-left: -10px;">
														<img :src="tarefa.criador.avatar" :title="tarefa.criador.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">

													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>

				<div class="row opcaoAccordion p-2 m-2 mt-1" id="headingDemais" 
						@click="toggleDemais"
						data-toggle="collapse" data-target="#collapseDemais" aria-expanded="true" aria-controls="collapseDemais">
					<i class="fas mt-1 mr-2"
						:class="{'fa-angle-right': isCollapsedDemais, 'fa-angle-down': !isCollapsedDemais}"
						></i> Demais {{kanban.periodoDemais}}
				</div>

				<div class="row collapse m-2 mt-2 kanban-periodo-scroll" id="collapseDemais" role="region" tabindex="0" aria-labelledby="headingDemais" data-parent="#accordionPeriodo">
					<div class="col-3 text-center">
						<div class="tituloColuna colunaFazer">
							<div class="central">
								<i class="far fa-clock mr-2"></i> A Fazer (<span v-if="selecao=='A'">{{demandaFazer.listaAtividadeDemais.length}}</span><span v-if="selecao=='T'">{{demandaFazer.listaTarefaDemais.length}}</span>)
							</div>
						</div>
						<div id="accordionFazerDemais">

							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFazer.listaAtividadeDemais" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }}  
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazerDemais">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Atividade" placement="top">
														<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Atividade" placement="top">
														<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Atividade" placement="top">
														<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFazer clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFazer.listaTarefaDemais" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }}  
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right;">
											Não Iniciada
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazerDemais">
									
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
													<el-tooltip content="Alterar Tarefa" placement="top">
														<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
													</el-tooltip>
													<el-tooltip content="Cancelar Tarefa" placement="top">
														<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
													</el-tooltip>
													<el-tooltip content="Concluir Tarefa" placement="top">
														<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
													</el-tooltip>
												</span>
												
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
					<div class="col-6">
						<div class="text-center tituloColuna colunaFazendo">
							<div class="central">
								<i class="fas fa-cog mr-2"></i> Fazendo (<span v-if="selecao=='A'">{{demandaFazendo.listaAtividadeDemais.length}}</span><span v-if="selecao=='T'">{{demandaFazendo.listaTarefaDemais.length}}</span>)
							</div>
						</div>
						<div class="row" id="accordionFazendoDemais">

							<div class="col-6" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='A'"
									v-for="atividade in demandaFazendo.listaAtividadeDemais" :key="atividade.idatividade">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': atividade.situacao=='ATRASADA', 'cartaoFazendo': atividade.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ atividade.idatividade"
										data-toggle="collapse"
										:data-target="`#collapseA`+ atividade.idatividade"
										aria-expanded="true"
										:aria-controls="`collapseA`+ atividade.idatividade">
										<div class="divTitulo">
											<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
												<i class="text-warning fas fa-star mr-1"></i>
											</el-tooltip>
											{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ atividade.dataInicio }} a {{ atividade.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': atividade.situacao=='ATRASADA'}">
												{{ descreverSituacao(atividade.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + atividade.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFazendoDemais">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Atividade" placement="top">
															<i @click="alterarAtividade(atividade)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Atividade" placement="top">
															<i @click="modalCancelarAtividade(atividade)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Atividade" placement="top">
															<i @click="concluirAtividade(atividade)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
							<div class="col-6" style="padding: 0px; margin-bottom: -8px;" v-if="selecao=='T'"
									v-for="tarefa in demandaFazendo.listaTarefaDemais" :key="tarefa.idtarefa">
								<div class="cartaoIndividual clickableKanban" 
										:class="{'cartaoAtrasado': tarefa.situacao=='ATRASADA', 'cartaoFazendo': tarefa.situacao!='ATRASADA'}">
									<div
										:id="`headingA`+ tarefa.idtarefa"
										data-toggle="collapse"
										:data-target="`#collapseA`+ tarefa.idtarefa"
										aria-expanded="true"
										:aria-controls="`collapseA`+ tarefa.idtarefa">
										<div class="divTitulo">
											{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
										</div>
										<div class="row" style="font-size: 10px; margin-top:15px">
											<div class="col-7">
												{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
											</div>
											<div class="col-5" style="text-align: right;"
													:class="{'corAtrasada': tarefa.situacao=='ATRASADA'}">
												{{ descreverSituacao(tarefa.situacao) }}
											</div>
										</div>
										<div class="progress mt-2" style="height: 3px; margin-bottom: 5px;">
											<div class="progress-bar" role="progressbar" :style="'width: ' + tarefa.progresso + '%;'"></div>
										</div>
									</div>
									<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFazendoDemais">
										
										<div class="row text-bold-6">
											<div class="col d-flex align-content-center flex-wrap">
												<div class="col">

													<span style="width: 25%; display: inline-block;">
														<span v-for="resp in tarefa.atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
															<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
														</span>
													</span>
													<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
														
														<el-tooltip content="Visualizar Atividade" placement="top">
															<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
														</el-tooltip>
														<el-tooltip content="Alterar Tarefa" placement="top">
															<i @click="modalAlterarTarefa(tarefa)" class="fas fa-edit ml-3 icones iconeAlterar"></i>
														</el-tooltip>
														<el-tooltip content="Cancelar Tarefa" placement="top">
															<i @click="modalCancelarTarefa(tarefa)" class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
														</el-tooltip>
														<el-tooltip content="Concluir Tarefa" placement="top">
															<i @click="concluirTarefa(tarefa)" class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
														</el-tooltip>
													</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="col-3 text-center">
						<div class="tituloColuna colunaFeito">
							<div class="central">
								<i class="far fa-check-circle mr-2"></i> Feito (<span v-if="selecao=='A'">{{demandaFeito.listaAtividadeDemais.length}}</span><span v-if="selecao=='T'">{{demandaFeito.listaTarefaDemais.length}}</span>)
							</div>
						</div>
						<div id="accordionFeitoDemais">

							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='A'"
									v-for="atividade in demandaFeito.listaAtividadeDemais" :key="atividade.idatividade">
								<div
									:id="`headingA`+ atividade.idatividade"
									data-toggle="collapse"
									:data-target="`#collapseA`+ atividade.idatividade"
									aria-expanded="true"
									:aria-controls="`collapseA`+ atividade.idatividade">
									<div class="divTitulo">
										<el-tooltip v-if="atividade.destaque" content="Atividade em destaque" placement="top">
											<i class="text-warning fas fa-star mr-1"></i>
										</el-tooltip>
										{{ (atividade.titulo.length > 100) ? atividade.titulo.substring(0, 100) +"... ("+ atividade.codigo +")" : atividade.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ atividade.dataInicio }} a {{ atividade.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ atividade.idatividade" class="collapse mt-3" :aria-labelledby="`headingA`+ atividade.idatividade" data-parent="#accordionFeitoDemais">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span v-for="resp in atividade.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
														<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">
													
													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="cartaoIndividual cartaoFeito clickableKanban" v-if="selecao=='T'"
									v-for="tarefa in demandaFeito.listaTarefaDemais" :key="tarefa.idtarefa">
								<div
									:id="`headingA`+ tarefa.idtarefa"
									data-toggle="collapse"
									:data-target="`#collapseA`+ tarefa.idtarefa"
									aria-expanded="true"
									:aria-controls="`collapseA`+ tarefa.idtarefa">
									<div class="divTitulo">
										{{ (tarefa.titulo.length > 100) ? tarefa.titulo.substring(0, 100) +"... ("+ tarefa.codigo +")" : tarefa.nomeCodigo }} 
									</div>
									<div class="row" style="font-size: 10px; margin-top:15px">
										<div class="col-7">
											{{ tarefa.dataInicio }} a {{ tarefa.dataFim }}
										</div>
										<div class="col-5" style="text-align: right; color: green">
											Concluída
										</div>
									</div>
								</div>
								<div :id="`collapseA`+ tarefa.idtarefa" class="collapse mt-3" :aria-labelledby="`headingA`+ tarefa.idtarefa" data-parent="#accordionFeitoDemais">
									<div class="row text-bold-6">
										<div class="col d-flex align-content-center flex-wrap">
											<div class="col">

												<span style="width: 25%; display: inline-block;">
													<span style="margin-left: -10px;">
														<img :src="tarefa.criador.avatar" :title="tarefa.criador.nome" width="27" class="rounded-circle">
													</span>
												</span>
												<span style="width: 75%; display: inline-block; text-align: right; text-wrap: nowrap;">

													<el-tooltip content="Visualizar Atividade" placement="top">
														<i @click="abrirModalAtividade(tarefa.atividade)" class="far fa-eye ml-3 icones iconeReagendar"></i>
													</el-tooltip>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="row opcaoAccordion p-2 m-2 mt-1" id="headingConsolidado"
						@click="toggleConsolidado"
						data-toggle="collapse" data-target="#collapseConsolidado" :aria-expanded="!isCollapsedConsolidado" aria-controls="collapseConsolidado">
					<i class="fas mt-1 mr-2"
						:class="{'fa-angle-right': isCollapsedConsolidado, 'fa-angle-down': !isCollapsedConsolidado}"></i> Consolidado
				</div>

				<KanbanConsolidado id="collapseConsolidado" class="collapse m-2 mt-2 kanban-periodo-scroll"
					role="region" tabindex="0" aria-labelledby="headingConsolidado" data-parent="#accordionPeriodo"
					:selecao="selecao" :kanban="kanban"
					@visualizar-atividade="abrirModalAtividade"
					@alterar-atividade="alterarAtividade"
					@alterar-tarefa="modalAlterarTarefa"
					@cancelar-atividade="modalCancelarAtividade"
					@cancelar-tarefa="modalCancelarTarefa"
					@concluir-atividade="concluirAtividade"
					@concluir-tarefa="concluirTarefa" />
			</div>
		</div>
		
		<modal id="modalAtv" :show.sync="modals.modalAtividade" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalAtividade()" class="pull-right clickableKanban close-icon" data-effect="fadeOut"><i
						class="fa fa-times"></i></span>
			</div>
			<Atividade v-if="modals.modalAtividade" @atualizar-lista="carregarKanban"
				@fechar-atividade="closeModalAtividade" @abrir-projeto="abrirModalProjeto"
				:atividadeSelecionada=atividadeModal />
		</modal>

		<modal id="modalProj" :show.sync="modals.modalProjeto" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalProjeto()" class="pull-right clickableKanban close-icon" data-effect="fadeOut"><i
						class="fa fa-times"></i></span>
			</div>
			<Projeto v-if="modals.modalProjeto" @fechar-projeto="closeModalProjeto"
				@abrir-atividade="abrirModalAtividade" :projetoSelecionado=projetoModal />
		</modal>
		
        <modal :show.sync="modals.modalCancelarTarefa">
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Cancelar Tarefa</h4>
                <div class="row">

                    <div class="col">
                        <label for="inputTitulo">
                            Justificativa do cancelamento
                            <el-tooltip content="Campo obrigatório" placement="top">
                                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                            </el-tooltip>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend mb-2">
                                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                            </div>
                            <textarea rows="2" 
                                v-model="tarefaCancelar.justificativa"
                                class="form-control mb-2"
                                maxlength="200"
                                placeholder="Preencha a justificativa"></textarea>
                        </div>
                    </div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" 
                                @click="fecharModalCancelarTarefa()"
                                class="btn btn-danger mr-3">
                            Desistir
                        </button>
                        <button type="button" 
                                @click="cancelarTarefa()"
                                class="btn btn-success ml-3">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </modal>
		
        <modal :show.sync="modals.modalAlterarTarefa">
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Alterar Tarefa</h4>
				<strong>Tarefa:</strong> &nbsp; {{ tarefaAlterarDescricao }}<br/>
				<br/>
                <div class="row">
					<div class="col-12">
						<input
							id="inputTitulo"
							maxlength="100"
							tabindex="1"
							type="text"
							class="form-control mb-2"
							v-model="tarefaAlterar.titulo"
							placeholder="Nome da Tarefa"
						/>
					</div>
					<div class="col-6">
						<flat-picker
							value=""
							tabindex="2"
							id="dataInicio"
							class="form-control datepicker mb-2"
							v-model="tarefaAlterar.dataInicio"
							placeholder="Data Início"
							:config="{
								allowInput: true,
								minDate: this.tarefaAlterar.atividade.dataInicio,
								maxDate: this.tarefaAlterar.atividade.dataFim,
								dateFormat: 'd/m/Y',
								altFormat: 'M j, Y',
							}"/>
					</div>
					<div class="col-6">
						<flat-picker
							value=""
							tabindex="3"
							id="dataFim"
							class="form-control datepicker mb-2"
							v-model="tarefaAlterar.dataFim"
							placeholder="Data Fim"
							:config="{
								allowInput: true,
								minDate: this.tarefaAlterar.dataInicio,
								maxDate: this.tarefaAlterar.atividade.dataFim,
								dateFormat: 'd/m/Y',
								altFormat: 'M j, Y',
							}"/>
					</div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" 
                                @click="fecharModalAlterarTarefa()"
                                class="btn btn-danger mr-3">
                            Desistir
                        </button>
                        <button type="button" 
                                @click="alterarTarefa()"
                                class="btn btn-success ml-3">
                            Alterar
                        </button>
                    </div>
                </div>
            </form>
        </modal>

        <modal :show.sync="modals.modalCancelarAtividade">
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Cancelar Atividade</h4>
                <div class="row">

                    <div class="col">
                        <label for="inputTitulo">
                            Justificativa do cancelamento
                            <el-tooltip content="Campo obrigatório" placement="top">
                                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                            </el-tooltip>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend mb-2">
                                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                            </div>
                            <textarea rows="2" 
                                v-model="atividadeCancelar.justificativa"
                                class="form-control mb-2"
                                maxlength="200"
                                placeholder="Preencha a justificativa"></textarea>
                        </div>
                    </div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" 
                                @click="fecharModalCancelarAtividade()"
                                class="btn btn-danger mr-3">
                            Desistir
                        </button>
                        <button type="button" 
                                @click="cancelarAtividade()"
                                class="btn btn-success ml-3">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </modal>     
	</div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "vue-select/dist/vue-select.css";
import Atividade from "../components/Atividade.vue";
import Projeto from "../components/Projeto.vue";
import KanbanAtrasados from "../components/KanbanAtrasados.vue";
import KanbanConsolidado from "../components/KanbanConsolidado.vue";

export default {
	components: {
		Atividade,
		Projeto,
		flatPicker,
		KanbanAtrasados,
		KanbanConsolidado,
	},
	created() {
		this.carregarTela();
	},
	data() {
		return {
			opcoes: [
				{ text: 'Atividades', value: 'A' },
				{ text: 'Tarefas', value: 'T' }
			],
			selecao: 'A',
			progress: true,
			perfil: false,
			kanban: {},
			kanbanRequisicao: 0,
			isCollapsedSemana: true,
			isCollapsedProxima: true,
			isCollapsedMes: true,
			isCollapsedDemais: true,
			isCollapsedConsolidado: true,
			responsavel: null,
			listaResponsaveis: [],
			projeto: null,
			listaProjetos: [],
			demandaFazer: {
				listaAtividadeSemana: [],
				listaAtividadeProxima: [],
				listaAtividade30: [],
				listaAtividadeDemais: [],
				listaTarefaSemana: [],
				listaTarefaProxima: [],
				listaTarefa30: [],
				listaTarefaDemais: [],
			},
			demandaFazendo: {
				listaAtividadeSemana: [],
				listaAtividadeProxima: [],
				listaAtividade30: [],
				listaAtividadeDemais: [],
				listaTarefaSemana: [],
				listaTarefaProxima: [],
				listaTarefa30: [],
				listaTarefaDemais: [],
			},
			demandaFeito: {
				listaAtividadeSemana: [],
				listaAtividadeProxima: [],
				listaAtividade30: [],
				listaAtividadeDemais: [],
				listaTarefaSemana: [],
				listaTarefaProxima: [],
				listaTarefa30: [],
				listaTarefaDemais: [],
			},
			demandaAtrasada: {
				listaAtividade: [],
				listaTarefa: [],
			},
            tarefaCancelar: {},
            tarefaAlterar: {
				atividade: {
					dataInicio: null,
					dataFim: null
				}
			},
			tarefaAlterarDescricao: "",
            atividadeCancelar: {},
			projetoModal: null,
			atividadeModal: null,
			modals: {
				modalProjeto: false,
				modalAtividade: false,
				modalCancelarAtividade: false,
				modalCancelarTarefa: false,
				modalAlterarTarefa: false,
			},
		};
	},
	methods: {
		carregarTela() {
			this.carregarProjetos();

			this.perfil = (localStorage.getItem("pnome") === "COORDENADOR");
			if (this.perfil) {
				this.carregarResponsavel();
			}
			this.carregarKanban();
		},
		alteracaoUsuario() {
			this.listaProjetos = [];
			this.projeto = null;
			this.carregarProjetos();
			this.carregarKanban();
		},
		carregarKanban() {
			const requisicao = ++this.kanbanRequisicao;
			var filtro = {
				responsavel: this.responsavel,
				projeto: this.projeto,
			};
			this.progress = true;
			this.$clubApi.post("/kanban", filtro).then((response) => {
				if (requisicao !== this.kanbanRequisicao) return;
				this.kanban = response.data.object;
				this.demandaAtrasada = this.kanban.demandaAtrasada || { listaAtividade: [], listaTarefa: [] };

				this.demandaFazer.listaAtividadeSemana = this.kanban.demandaSemana.listaAtividade.filter((atividade) => atividade.situacao == "NAOINICIADA")
				this.demandaFazer.listaAtividadeProxima = this.kanban.demandaProxima.listaAtividade.filter((atividade) => atividade.situacao == "NAOINICIADA")
				this.demandaFazer.listaAtividade30 = this.kanban.demanda30.listaAtividade.filter((atividade) => atividade.situacao == "NAOINICIADA")
				this.demandaFazer.listaAtividadeDemais = this.kanban.demandaDemais.listaAtividade.filter((atividade) => atividade.situacao == "NAOINICIADA")
				this.demandaFazer.listaTarefaSemana = this.kanban.demandaSemana.listaTarefa.filter((tarefa) => tarefa.situacao == "NAOINICIADA")
				this.demandaFazer.listaTarefaProxima = this.kanban.demandaProxima.listaTarefa.filter((tarefa) => tarefa.situacao == "NAOINICIADA")
				this.demandaFazer.listaTarefa30 = this.kanban.demanda30.listaTarefa.filter((tarefa) => tarefa.situacao == "NAOINICIADA")
				this.demandaFazer.listaTarefaDemais = this.kanban.demandaDemais.listaTarefa.filter((tarefa) => tarefa.situacao == "NAOINICIADA")

				this.demandaFazendo.listaAtividadeSemana = this.kanban.demandaSemana.listaAtividade.filter((atividade) => atividade.situacao == "EMANDAMENTO")
				this.demandaFazendo.listaAtividadeProxima = this.kanban.demandaProxima.listaAtividade.filter((atividade) => atividade.situacao == "EMANDAMENTO")
				this.demandaFazendo.listaAtividade30 = this.kanban.demanda30.listaAtividade.filter((atividade) => atividade.situacao == "EMANDAMENTO")
				this.demandaFazendo.listaAtividadeDemais = this.kanban.demandaDemais.listaAtividade.filter((atividade) => atividade.situacao == "EMANDAMENTO")
				this.demandaFazendo.listaTarefaSemana = this.kanban.demandaSemana.listaTarefa.filter((tarefa) => tarefa.situacao == "EMANDAMENTO")
				this.demandaFazendo.listaTarefaProxima = this.kanban.demandaProxima.listaTarefa.filter((tarefa) => tarefa.situacao == "EMANDAMENTO")
				this.demandaFazendo.listaTarefa30 = this.kanban.demanda30.listaTarefa.filter((tarefa) => tarefa.situacao == "EMANDAMENTO")
				this.demandaFazendo.listaTarefaDemais = this.kanban.demandaDemais.listaTarefa.filter((tarefa) => tarefa.situacao == "EMANDAMENTO")
				
				this.demandaFeito.listaAtividadeSemana = this.kanban.demandaSemana.listaAtividade.filter((atividade) => atividade.situacao == "CONCLUIDA")
				this.demandaFeito.listaAtividadeProxima = this.kanban.demandaProxima.listaAtividade.filter((atividade) => atividade.situacao == "CONCLUIDA")
				this.demandaFeito.listaAtividade30 = this.kanban.demanda30.listaAtividade.filter((atividade) => atividade.situacao == "CONCLUIDA")
				this.demandaFeito.listaAtividadeDemais = this.kanban.demandaDemais.listaAtividade.filter((atividade) => atividade.situacao == "CONCLUIDA")
				this.demandaFeito.listaTarefaSemana = this.kanban.demandaSemana.listaTarefa.filter((tarefa) => tarefa.situacao == "CONCLUIDA")
				this.demandaFeito.listaTarefaProxima = this.kanban.demandaProxima.listaTarefa.filter((tarefa) => tarefa.situacao == "CONCLUIDA")
				this.demandaFeito.listaTarefa30 = this.kanban.demanda30.listaTarefa.filter((tarefa) => tarefa.situacao == "CONCLUIDA")
				this.demandaFeito.listaTarefaDemais = this.kanban.demandaDemais.listaTarefa.filter((tarefa) => tarefa.situacao == "CONCLUIDA")
			})
			.catch((error) => {
				if (requisicao !== this.kanbanRequisicao) return;
				console.log("--->", error);
				this.$toastr.warning(error);
			})
			.finally(() => {
				if (requisicao === this.kanbanRequisicao) this.progress = false;
			});
		},
		carregarProjetos(){

			if (this.responsavel == null || this.responsavel.length == 0) {
				var pefil = {
					perfil: localStorage.getItem("trocaPerfil")
				}
				this.$clubApi.post("/atividade/projetos/abertosperfil", pefil).then((response) => {
					this.listaProjetos = response.data.object;
				})
				.catch((error) => {
					this.$toastr.warning(error.response.data.msg);
				});
			} else {
				this.$clubApi.post("/projetos/atividade/responsaveis", this.responsavel).then((response) => {
					this.listaProjetos = response.data.object;
				})
				.catch((error) => {
					this.$toastr.warning(error.response.data.msg);
				});
			}
		},
		carregarResponsavel() {
			this.$clubApi.get("/user/responsaveis").then((response) => {
				this.listaResponsaveis = [{idusuario: 0, nome: "Todos"}];
				response.data.object.forEach(usuario => {
					this.listaResponsaveis.push(usuario);
				});
			})
			.catch((error) => {
				this.$toastr.warning(error.response.data.msg);
			});
		},
		descreverSituacao(situacao) {
			if (situacao === 'EMANDAMENTO') {
				return "Em Andamento";
			}
			if (situacao === 'ATRASADA') {
				return "Atrasada";
			}
		},
		toggleSemana() {
			this.isCollapsedSemana = !this.isCollapsedSemana;
			this.isCollapsedProxima = true;
			this.isCollapsedMes = true;
			this.isCollapsedDemais = true;
			this.isCollapsedConsolidado = true;
		},
		toggleProxima() {
			this.isCollapsedProxima = !this.isCollapsedProxima;
			this.isCollapsedSemana = true;
			this.isCollapsedMes = true;
			this.isCollapsedDemais = true;
			this.isCollapsedConsolidado = true;
		},
		toggleMes() {
			this.isCollapsedMes = !this.isCollapsedMes;
			this.isCollapsedSemana = true;
			this.isCollapsedProxima = true;
			this.isCollapsedDemais = true;
			this.isCollapsedConsolidado = true;
		},
		toggleDemais() {
			this.isCollapsedDemais = !this.isCollapsedDemais;
			this.isCollapsedSemana = true;
			this.isCollapsedProxima = true;
			this.isCollapsedMes = true;
			this.isCollapsedConsolidado = true;
		},
		toggleConsolidado() {
			this.isCollapsedConsolidado = !this.isCollapsedConsolidado;
			this.isCollapsedSemana = true;
			this.isCollapsedProxima = true;
			this.isCollapsedMes = true;
			this.isCollapsedDemais = true;
		},

		// Ações dos botões de cada card
		abrirModalProjeto(projeto) {
			this.projetoModal = projeto;
			this.modals.modalProjeto = true;
		},
		closeModalProjeto() {
			this.modals.modalProjeto = false;
		},
		abrirModalAtividade(atividade) {
			this.atividadeModal = atividade;
			this.modals.modalAtividade = true;
		},
		closeModalAtividade() {
			this.modals.modalAtividade = false;
		},
        alterarAtividade(atividade){
            location.href = '/atividade-cadastro/'+ atividade.idatividade;
        },
        modalCancelarAtividade(atividade) {
            this.atividadeCancelar = atividade;
            this.atividadeCancelar.justificativa = null;
            this.modals.modalCancelarAtividade = true;
        },
        fecharModalCancelarAtividade() {
            this.modals.modalCancelarAtividade = false;
        },
        cancelarAtividade() {
            if (this.validaAtividadeCancelar()) {
				if (confirm('Deseja realmente CANCELAR essa Atividade?\n\nTodas as tarefas relacionadas à essa atividade serão canceladas')) {
                    this.progress = true;
                    this.$clubApi.post("/atividade/cancelar", this.atividadeCancelar).then(() => {
                        this.atividadeCancelar.justificativa = null;
                        this.atividadeCancelar = {};
                        this.modals.modalCancelarAtividade = false;
                        this.carregarKanban();
                        this.$toastr.success("Atividade cancelada com sucesso!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progress = false;
                    });
                }
            }
        },
		validaAtividadeCancelar() {
			var camposValidos = true;
			if (this.atividadeCancelar.justificativa == null ||
                    this.atividadeCancelar.justificativa.trim() == "") {
				this.$toastr.error("Justificativa do cancelamento da Atividade obrigatória!");
				camposValidos = false;
			}
			return camposValidos;
		},
        concluirAtividade(atividade) {
			if (confirm('Deseja realmente CONCLUIR a Atividade:\n- '+ 
                    atividade.codigoNome +'\n\nTodas as tarefas relacionadas à essa atividade serão concluídas.')) {
                this.progress = true;
                this.$clubApi.post("/atividade/concluir", atividade).then(() => {
                    this.carregarKanban();
                    this.$toastr.success("Atividade concluída com sucesso!");
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progress = false;
                });
            }
        },
        modalCancelarTarefa(tarefa) {
            this.tarefaCancelar = tarefa;
            this.tarefaCancelar.justificativa = null;
            this.modals.modalCancelarTarefa = true;
        },
        fecharModalCancelarTarefa() {
            this.modals.modalCancelarTarefa = false;
        },
        cancelarTarefa() {
            if (this.validaTarefaCancelar()) {
				if (confirm('Deseja realmente cancelar essa tarefa?')) {
                    this.progress = true;
                    this.$clubApi.post("/atividade/tarefa/cancelar", this.tarefaCancelar).then(() => {
                        this.$toastr.success("Tarefa cancelada com sucesso!");
                        this.modals.modalCancelarTarefa = false;
                        this.carregarKanban();
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progress = false;
                    });
                }
            }
        },
		validaTarefaCancelar() {
			var camposValidos = true;
			if (this.tarefaCancelar.justificativa == null ||
                    this.tarefaCancelar.justificativa.trim() == "") {
				this.$toastr.error("Justificativa do cancelamento da Tarefa obrigatória!");
				camposValidos = false;
			}
			return camposValidos;
		},
        concluirTarefa(tarefa) {
			if (confirm('Deseja realmente concluir a tarefa:\n- '+ tarefa.codigoNome +'?')) {
                this.progress = true;
                this.$clubApi.post("/atividade/tarefa/concluir", tarefa).then(() => {
					this.$toastr.success("Tarefa concluída com sucesso!");
                    this.carregarKanban();
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progress = false;
                });
            }
        },
		modalAlterarTarefa(tarefa) {
			console.log("tarefatarefatarefatarefa", tarefa);
            this.tarefaAlterar = tarefa;
			this.tarefaAlterarDescricao = tarefa.titulo;
            this.modals.modalAlterarTarefa = true;
		},
        fecharModalAlterarTarefa() {
            this.modals.modalAlterarTarefa = false;
        },
        alterarTarefa() {
            if (this.validaTarefa()) {
				if (confirm('Deseja alterar a tarefa?')) {
                    this.progress = true;
					this.tarefaAlterar.idatividade = this.tarefaAlterar.atividade.idatividade;
                    this.$clubApi.post("/atividade/tarefa", this.tarefaAlterar).then(() => {
						this.$toastr.success("Tarefa alterada com sucesso!");
						this.carregarKanban();
						this.fecharModalAlterarTarefa()
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
					.finally(() => {
						this.progress = false;
					});
				}
            }
        },
		validaTarefa() {
			if (this.tarefaAlterar.dataFim == "") {
				this.$toastr.error("Data fim da Tarefa obrigatória!");
				return false;
			}
			if (this.tarefaAlterar.dataInicio == "") {
				this.$toastr.error("Data início da Tarefa obrigatória!");
				return false;
			}
			if (this.tarefaAlterar.titulo == null) {
				this.$toastr.error("Nome da Tarefa obrigatório!");
				return false;
			}
			return true;
		},
	},
};
</script>
<style>
.kanbanGeral {
	width: 99%;
}
.kanban-periodo-scroll {
	/* Limite relativo à tela, sem impor altura mínima aos quadros curtos. */
	max-height: 600px;
	max-height: min(65vh, 600px);
	max-height: min(65dvh, 600px);
	align-content: flex-start;
}
.kanban-periodo-scroll.collapse.show {
	/* Não interfere no overflow: hidden da animação .collapsing do Bootstrap. */
	overflow-y: auto;
	overflow-x: hidden;
	padding-bottom: 8px;
	-webkit-overflow-scrolling: touch;
}
.clickableKanban {
  cursor: pointer;
  transition: transform 0.1s ease-in-out;
}
.clickableKanban:hover {
  cursor: pointer;
  transform: scale(1.03);
}
.tituloColuna {
	font-size: 14px;
	background-color: #f2f2f2;
	font-weight: 700;
	height: 30px;
	border-radius: 5px;
  	/*border-bottom: 1px solid #aeaeae;*/
}

.colunaFazer {
	color: #555bb0;
	border-bottom: 1px solid #000441;
}
.colunaFazendo {
	color: #9a0;
	border-bottom: 1px solid #4f5706;
}
.colunaFeito {
	color: #109b23;
	border-bottom: 1px solid #06490f;
}

.central {
	padding-top: 5px;
}

.opcaoAccordion {
    font-size: 14px;
    font-weight: 600;
	cursor: pointer;
	background-color: #e6e6e6;
	border-radius: 5px;
}

.cartaoIndividual {
	font-size: 13px;
	margin: 8px;
	border: 1px solid #e6e6e6;
	border-radius: 5px;
	padding: 8px;
	background-color: #f9f9f9;
  	box-shadow: 3px 4px 6px #e8e8e8;
	text-align: left;
	min-height: 122px;
}
.cartaoFazer {
	border-left: 2px solid #2977bb;
}
.cartaoFazendo {
	border-left: 2px solid #b8bb29;
}
.cartaoFeito {
	border-left: 2px solid #29bb35;
}
.cartaoAtrasado {
	border: 1px solid #e7a7a7;
	background-color: #fcf1f1;
	border-left: 2px solid #df4949;
}

.icones {
    color: #0f0044;
    cursor: pointer;
    font-size: 17px;
}
.iconeCancelar:hover {
    color: red;
}
.iconeConcluir:hover {
    color: green;
}
.iconeAlterar:hover {
    color: #979700;
}
.iconeReagendar:hover {
    color: #0000ff;
}

.fonteProgresso {
    color: #0f0044;
	font-size: 18px;
	font-style: italic;
}
.fonteAtrasado {
	color: #df4949;
	font-size: 14px;
	font-style: italic;
	font-weight: 600;
}
.corAtrasada {
	color: #df4949;
}
.divTitulo {
	min-height: 58px;
}
</style>
